import SelectionState from "state/selections/SelectionState";
import { selectDefinitions, selectFetchingData } from "./selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingData = useSelector(selectFetchingData);
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.map((def) => ({
      headerName: "Account Duration Relative to Target",
      field: "targetMajorAccountDuration",
      colId: "targetMajorAccountDuration",
      loading: fetchingData,
      X_onDelete: () => dispatch(deleteColumn(def)),
    }));
  }, [definitions, dispatch, fetchingData]);
};
